<template>
  <div>
    <div>
      <div class="card col align-center col-sm-10 col-md-8 col-xl-6 my-7">
        <div class="card-body pt-6 pb-0">
          <div class="tab-content">
            <!--begin::Tap pane-->
            <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
              <v-select
                :items="barrelSizeOptions"
                label="Select Barrel Size"
                solo
                v-model="order.barrelSize"
                @change="updateSelectedSize"
              ></v-select>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
      <div
        v-if="selectedSize"
        class="col-12 align-center col-sm-10 col-md-8 col-xl-6 mb-5 mb-lg-0"
      >
        <v-carousel
          light
          :show-arrows="showNavArrow(selectedSize)"
          show-arrows-on-hover
          hide-delimiter-background
          :hide-delimiters="!showNavArrow(selectedSize)"
          delimiter-icon="mdi-minus"
          v-model="currentIndex"
        >
          <v-carousel-item
            v-for="capacityOption in barrelOptions[selectedSize]"
            :key="capacityOption.capacity"
          >
            <label class="d-flex flex-stack cursor-pointer">
              <span
                class="
                  nav-link
                  btn
                  btn-flex
                  btn-color-gray-400
                  btn-outline
                  btn-outline-default
                  btn-active-grey
                  d-flex
                  flex-grow-1 flex-column flex-center
                  pt-8
                  pb-12
                "
                data-bs-toggle="tab"
                href="#kt_general_widget_1_1"
              >
                <span
                  class="card-label bigger-label fw-bolder text-dark mb-5 mt-5"
                  >{{ capacityOption.name }}</span
                >

                <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                <img
                  alt="help"
                  src="@/assets/media/full-pink.png"
                  class="h-lg-150px"
                />

                <div class="details_barrel">
                  <div class="sectionbreak mt-5 my-2">
                    <span class="badge badge-light-success">Capacity</span>
                    <!--end::Svg Icon-->
                    <span class="fs-5 fw-bold text-dark">{{
                      capacityOption.size
                    }}</span>
                  </div>
                  <div class="sectionbreak mb-2">
                    <!-- <span class="badge badge-light-success">Order Date</span> -->
                    <!--end::Svg Icon-->
                    <span class="fs-1 fw-bold text-dark text-center d-block"
                      >${{ capacityOption.barrelCost }} USD</span
                    >
                  </div>
                  <div class="sectionbreak mb-2"></div>
                </div>
              </span>
            </label>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrderBarrelOptionsCarousel",
  components: {  },
  props: {
    barrelSizeOptions: {
      type: Array,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    barrelOptions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    selectedSize() {
      return this.order.barrelSize;
    },
  },
  watch: {
    currentIndex: function () {
      this.order.capacity =
        this.barrelOptions[this.selectedSize][this.currentIndex].capacity;
    },
  },
  methods: {
    showNavArrow(size) {
      return this.barrelOptions[size]?.length > 1;
    },
    updateSelectedSize(size) {
      this.order.capacity = this.barrelOptions[size][0].capacity;
      this.order.barrelSize = size;
    },
  },
};
</script>

<style>
#barrelFitImage {
  max-width: 750px;
  max-height: 90vh;
}
</style>